module.exports = __webpack_public_path__ + "static/media/web-grid-alt.deb87867.svg";